<template>
  <section class="fullpad position-relative bg-asphalt">
    <div class="container position-relative roi-step">
      <StepHeading :has-icon="hasIcon" />

      <StepForm v-if="hasForm">
        <slot />
      </StepForm>

      <template v-else>
        <slot />

        <Stepper v-if="hasStepper" />
      </template>
    </div>
  </section>
</template>

<script>
import StepForm from './StepForm.vue';
import StepHeading from './StepHeading.vue';
import Stepper from './Stepper.vue';

export default {
  name: 'StepContainer',

  components: { StepHeading, StepForm, Stepper },

  props: {
    hasForm: {
      type: Boolean,
      required: false,
      default: true,
    },
    hasStepper: {
      type: Boolean,
      required: false,
      default: true,
    },
    hasIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
};
</script>
